<form
  *ngIf="_storageAccount"
  [formGroup]="form">
  <ng-container *ngIf="viewMode === 'modal'">
    <ng-container [ngTemplateOutlet]="displayName"></ng-container>

    <ng-container [ngTemplateOutlet]="createNewGroup"></ng-container>

    <ng-container [ngTemplateOutlet]="inputGroup"></ng-container>

    <ng-container [ngTemplateOutlet]="manualEnteringLoader"></ng-container>

    <ng-container [ngTemplateOutlet]="objectLock"></ng-container>

    <ng-container [ngTemplateOutlet]="s3Accelerator"></ng-container>

    <ng-container [ngTemplateOutlet]="reuseAccountRulesTemplate"></ng-container>

    <ng-container [ngTemplateOutlet]="companies"></ng-container>
  </ng-container>

  <ng-container *ngIf="viewMode === 'wizard'">
    <mbs-card class="card-form">
      <mbs-card-group>
        <ng-container [ngTemplateOutlet]="displayName"></ng-container>
      </mbs-card-group>

      <mbs-card-group>
        <ng-container [ngTemplateOutlet]="createNewGroup"></ng-container>
        <ng-container [ngTemplateOutlet]="inputGroup"></ng-container>
        <ng-container [ngTemplateOutlet]="objectLock"></ng-container>
        <ng-container [ngTemplateOutlet]="s3Accelerator"></ng-container>
      </mbs-card-group>

      <mbs-card-group>
        <ng-container [ngTemplateOutlet]="companies"></ng-container>
      </mbs-card-group>
    </mbs-card>
  </ng-container>
</form>

<ng-template #displayName>
  <div class="mbs-form-group">
    <mbs-input
      [formControl]="displayNameControl"
      [showRequiredMark]="false"
      [placeholder]="'shared:modals.addDestinationBucket.displayNamePlaceholder' | i18next: { format: 'capitalize' }"
      [boldLabel]="true"
      [label]="'shared:common.displayName' | i18next: { format: 'capitalize' }"></mbs-input>
  </div>
</ng-template>

<ng-template #createNewGroup>
  <ng-container *ngIf="!blockForm && !_storageAccount.isPrivateStorage">
    <div class="mbs-form-group">
      <mbs-button-group
        class="w-100"
        customClasses="w-100">
        <mbs-button
          [type]="'secondary'"
          class="flex-basis-50"
          customClasses="w-100 justify-content-center"
          [active]="createNew.value"
          (click)="createNew.patchValue(true)">
          {{ 'shared:modals.addDestinationBucket.newBucket' | i18next: { type: bucketTypeName } }}
        </mbs-button>
        <mbs-button
          [type]="'secondary'"
          class="flex-basis-50"
          customClasses="w-100 justify-content-center"
          [active]="!createNew.value"
          (click)="createNew.patchValue(false)">
          {{ 'shared:modals.addDestinationBucket.existingBucket' | i18next: { type: bucketTypeName } }}
        </mbs-button>
      </mbs-button-group>
    </div>
  </ng-container>
</ng-template>

<ng-template #inputGroup>
  <div class="mbs-form-group">
    <div class="form-row">
      <ng-container *ngIf="createNew.value; else existingBucket">
        <div class="col-6">
          <mbs-input
            [formControl]="bucketNameControl"
            [placeholder]="
              'shared:modals.addDestinationBucket.bucketNamePlaceholder' | i18next: { format: 'capitalize', type: bucketTypeName }
            "
            [showRequiredMark]="false"
            [boldLabel]="true"
            [label]="'shared:modals.addDestinationBucket.bucketName' | i18next: { format: 'capitalize', type: bucketTypeName }">
            <ng-container appendLabel>
              <span
                class="ico ico-InfoCircle ml-2 cursor-help text-info"
                tooltipClass="tooltip-xl"
                container="body"
                [placement]="'right'"
                [ngbTooltip]="rules"></span>
              <ng-template #rules>
                <ul class="text-start m-0 p-3">
                  <li
                    *ngFor="let item of bucketNameRules; let last = last"
                    class="text-md ml-2 mb-1 pb-0">
                    {{ item }}<br *ngIf="!last" />
                  </li>
                </ul>
              </ng-template>
            </ng-container>
          </mbs-input>
        </div>

        <ng-container *ngIf="_storageAccount?.supportedStorageClass">
          <div class="col-6">
            <mbs-select
              [formControl]="storageClassControl"
              [items]="storageClasses"
              [placeholder]="'shared:modals.addDestinationBucket.storageClassPlaceholder' | i18next: { format: 'capitalize' }"
              [showRequiredMark]="false"
              [clearable]="false"
              [appendTo]="'.modal-content'"
              bindLabel="name"
              [boldLabel]="true"
              [label]="'shared:modals.addDestinationBucket.storageClass' | i18next: { format: 'capitalize' }"></mbs-select>
          </div>
        </ng-container>

        <ng-container *ngIf="_storageAccount?.supportedBucketLocation">
          <div
            class="col-6"
            [class.mt-3]="googleCloudAccounts.includes(_storageAccount.storageType)">
            <mbs-select
              [formControl]="regionControl"
              [items]="regions"
              [clearable]="false"
              [placeholder]="
                (googleCloudAccounts.includes(_storageAccount?.storageType)
                  ? 'shared:modals.addDestinationBucket.locationPlaceholder'
                  : 'shared:placeholders.region'
                ) | i18next: { format: 'capitalize' }
              "
              [showRequiredMark]="false"
              [loading]="specificGCDataLoading"
              [appendTo]="'.modal-content'"
              bindLabel="displayName"
              [boldLabel]="true"
              [label]="
                (googleCloudAccounts.includes(_storageAccount?.storageType)
                  ? 'shared:modals.addDestinationBucket.location'
                  : 'shared:storages.region'
                ) | i18next: { format: 'capitalize' }
              "
              [clearUnavailableSelection]="true"></mbs-select>
          </div>
        </ng-container>

        <ng-container *ngIf="googleCloudAccounts.includes(_storageAccount?.storageType)">
          <div class="col-6 mt-3">
            <mbs-select
              [formControl]="googleDestinationSubregionControl"
              [items]="googleSubregions"
              [showRequiredMark]="false"
              [placeholder]="'shared:modals.addDestinationBucket.regionalLocationPlaceholder' | i18next: { format: 'capitalize' }"
              [loading]="specificGCDataLoading && googleDestinationSubregionControl.enabled"
              [clearable]="false"
              [appendTo]="'.modal-content'"
              bindLabel="displayName"
              [boldLabel]="true"
              [label]="'shared:modals.addDestinationBucket.regionalLocation' | i18next: { format: 'capitalize' }"></mbs-select>
          </div>
        </ng-container>
      </ng-container>

      <ng-template #existingBucket>
        <ng-container *ngIf="_storageAccount?.supportedExternalBucket && !blockForm">
          <div class="mbs-form-group col-12">
            <mbs-switcher
              [formControl]="isExternalBucketControl"
              [boldLabel]="true"
              [label]="'shared:modals.addDestinationBucket.externalBucketTitle' | i18next: { type: bucketTypeName }">
              <ng-template switcherDescription>
                <div class="add-destination-form_switcher-description text-sm">
                  {{ 'shared:modals.addDestinationBucket.externalBucketDescription' | i18next }}
                </div>
              </ng-template>
            </mbs-switcher>
          </div>
        </ng-container>

        <ng-container *ngIf="!isManualBucketEntering() && !blockForm; else plainInput">
          <div class="col-12">
            <mbs-select
              [formControl]="bucketNameControl"
              [clearable]="false"
              [showRequiredMark]="false"
              [placeholder]="
                'shared:modals.addDestinationBucket.selectBucketName' | i18next: { format: 'capitalize', type: bucketTypeName }
              "
              [loading]="bucketsLoading"
              [appendTo]="'.modal-content'"
              bindLabel="bucketName"
              bindValue="bucketName"
              [items]="bucketsNames"
              [boldLabel]="true"
              [label]="
                'shared:modals.addDestinationBucket.bucketName' | i18next: { format: 'capitalize', type: bucketTypeName }
              "></mbs-select>
          </div>
        </ng-container>

        <ng-template #plainInput>
          <mbs-alert
            *ngIf="!isExternalBucketControl.value && !blockForm"
            [icon]="true"
            [type]="mbsPopupType.warning">
            <div [innerHTML]="getManualBucketEnteringAlertText()"></div>
          </mbs-alert>

          <div class="col-12">
            <mbs-input
              [formControl]="bucketNameControl"
              [placeholder]="'shared:modals.addDestinationBucket.enterBucketName' | i18next: { format: 'capitalize', type: bucketTypeName }"
              [showRequiredMark]="false"
              [boldLabel]="true"
              [disabledSelf]="manualBucketLoading"
              [label]="
                (isExternalBucketControl?.value
                  ? 'shared:modals.addDestinationBucket.externalBucketName'
                  : 'shared:modals.addDestinationBucket.bucketName'
                ) | i18next: { format: 'capitalize', type: bucketTypeName }
              ">
            </mbs-input>
          </div>
        </ng-template>
      </ng-template>
    </div>
  </div>
</ng-template>

<ng-template #manualEnteringLoader>
  <ng-container *ngIf="manualBucketLoading">
    <div class="d-flex justify-content-center mt-4">
      <span class="loader loader-lg"></span>
    </div>
  </ng-container>
</ng-template>

<ng-template #objectLock>
  <div
    *ngIf="_storageAccount?.immutabilitySupported"
    class="mbs-form-group">
    <ng-container *ngIf="createNew.value || !!currentBucket || _storageAccount.isPrivateStorage || blockForm; else pending">
      <ng-container
        *ngIf="
          createNew.value ||
            currentBucket?.immutabilitySupported ||
            !(permissionsEnum.ManageImmutability | can: 'read') ||
            _storageAccount.isPrivateStorage ||
            blockForm;
          else cannotBeChanged
        ">
        <mbs-switcher
          [formControl]="immutabilityControl"
          [disabledSelf]="!(permissionsEnum.ManageImmutability | can: 'read')"
          [ngbTooltip]="
            (permissionsEnum.ManageImmutability | can: 'read')
              ? ''
              : ('shared:modals.addDestinationBucket.objectLockDisabledByPermission' | i18next)
          "
          [boldLabel]="true"
          [label]="'shared:modals.addDestinationBucket.objectLockTitle' | i18next">
          <ng-template switcherDescription>
            <div class="add-destination-form_switcher-description text-sm">
              <span class="mr-2">{{ 'shared:modals.addDestinationBucket.objectLockDescription' | i18next: { type: bucketTypeName } }}</span>
              <a
                *ngIf="permissionsEnum.HelpMarketing | can: 'read'"
                target="_blank"
                [href]="'/AP/Help/backup/about/gfs/immutability'"
                >{{ 'shared:buttons.learnMore' | i18next }}</a
              >
            </div>
          </ng-template>
        </mbs-switcher>
      </ng-container>

      <ng-template #cannotBeChanged>
        <div class="fw-bold">{{ 'shared:modals.addDestinationBucket.objectLockDisabledTitle' | i18next }}</div>
        <div>
          {{
            (currentBucket && currentBucket?.immutabilitySupported === null
              ? 'shared:modals.addDestinationBucket.objectLockDisabledByPolicy'
              : 'shared:modals.addDestinationBucket.objectLockDisabledDescription'
            ) | i18next: { type: bucketTypeName }
          }}
        </div>
      </ng-template>
    </ng-container>

    <ng-template #pending>
      <ng-container *ngIf="form.value?.bucketName && !manualEnteringLoader">
        <div class="d-flex justify-content-center mt-4">
          <span class="loader loader-lg"></span>
        </div>
      </ng-container>
    </ng-template>
  </div>
</ng-template>

<ng-template #s3Accelerator>
  <ng-container
    *ngIf="
      _storageAccount?.supportedS3Accelerator && (createNew?.value || currentBucket || this._storageAccount.isPrivateStorage || blockForm)
    ">
    <div class="mbs-form-group">
      <ng-container *ngIf="!createNew?.value && currentBucket && currentBucket?.s3AcceleratorEnabled === null; else switcher">
        <div class="fw-bold">{{ 'shared:modals.addDestinationBucket.s3AcceleratorTitle' | i18next }}</div>
        <div>
          {{ 'shared:modals.addDestinationBucket.s3AcceleratorDisabledByPolicy' | i18next: { type: bucketTypeName } }}
        </div>
      </ng-container>

      <ng-template #switcher>
        <mbs-switcher
          [formControl]="s3AcceleratorControl"
          [boldLabel]="true"
          [label]="'shared:modals.addDestinationBucket.s3AcceleratorTitle' | i18next">
          <ng-template switcherDescription>
            <div class="add-destination-form_switcher-description text-sm">
              <span class="mr-2">{{
                'shared:modals.addDestinationBucket.s3AcceleratorDescription' | i18next: { type: bucketTypeName }
              }}</span>
              <a
                *ngIf="permissionsEnum.HelpMarketing | can: 'read'"
                target="_blank"
                [href]="'https://docs.aws.amazon.com/AmazonS3/latest/userguide/transfer-acceleration.html#transfer-acceleration-why-use'"
                >{{ 'shared:buttons.learnMore' | i18next }}</a
              >
            </div>
          </ng-template>
        </mbs-switcher>
      </ng-template>
    </div>
  </ng-container>
</ng-template>

<ng-template #reuseAccountRulesTemplate>
  <ng-container *ngIf="_storageAccount?.accountAzureLifecycleRule">
    <ng-container
      *ngIf="
        createNew?.value ||
        (currentBucket?.bucketName && currentBucket?.bucketName !== destination?.bucket?.bucketName) ||
        isManualBucketEntering()
      ">
      <div class="mbs-form-group">
        <mbs-switcher
          [formControl]="reuseAccountRules"
          [boldLabel]="true"
          [label]="'shared:modals.addDestinationBucket.reuseStorageRules' | i18next">
        </mbs-switcher>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #companies>
  <div class="mbs-form-group">
    <h5
      class="mb-0"
      [class.text-disabled]="destination?.isReadOnly">
      {{ 'shared:common.companies' | i18next: { format: 'title' } }}
    </h5>
    <div
      class="mb-2"
      [class.text-disabled]="destination?.isReadOnly">
      {{ 'shared:modals.addDestinationBucket.companyExplanation' | i18next }}
    </div>

    <mbs-company-select
      [multiple]="true"
      [formControl]="companiesControl"
      [selectedIds]="selectedCompanyIds"
      [clearable]="false"
      [showAddNewButton]="true"
      appendTo=".modal-content">
    </mbs-company-select>
  </div>
</ng-template>
